import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class KarticaArtiklaService {
  constructor(private _http: HttpClient) {}

  vrstaDokumentaPopis(a: any) {
		return this._http.post(AppConfig.ipAddress + 'maticni_vrstaDokumentaPopis', a)
			.pipe(map((res: any) => res));
	}

  artiklPopis(a: any) {
		return this._http.post(AppConfig.ipAddress + 'artiklPopis', a)
			.pipe(map((res: any) => res));
	}

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  izvjestajKarticaArtikla(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izvjestajKarticaArtikla', a)
      .pipe(map((res: any) => res));
  }



}